module.exports = __webpack_public_path__ + "img/vignettes-asso_0017_samu-social-paris.9ac86a11.jpg";